import React, { useEffect } from 'react'
import PartnerHeader from './PartnerHeader'
import { Banner, CardBox, PartnerContainer } from '../../style/partnerStylemain'
import banner from '../../img/partnerBanner.png'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PartnerStepper from './PartnerStepper';
import { StepPage } from './constant/StepPage';
type Props = {}

const PartnerThankyouNotInterest = (props: Props) => {
    useEffect(()=>{
        sessionStorage.removeItem("listCategory");
    },[])
    return (
        <div className='bg-light-gray partner-page' style={{ height: "100vh", fontFamily: "DB Helvethaica" }}>
            <div style={{ position: 'sticky', top: 0 }}>
                <div className="student-wrapper-header-inner" style={{ background: "#38383D" }}>
                    <PartnerHeader />
                </div>
            </div>
            <PartnerContainer className='mt-5'>
                <Banner src={banner}></Banner>
                <h2 className='text-center mt-3' ><br/></h2>
                <CardBox>
                    <div className='text-center'>
                        <CheckCircleIcon className='my-4' style={{fontSize:80,color:"#53a451"}}/>
                    </div>
                    <div className='text-center' style={{fontSize:22}}>
                    ตลาดหลักทรัพย์แห่งประเทศไทย<br/> หวังเป็นอย่างยิ่งว่าจะได้ร่วมมือส่งเสริมความรู้<br/>ให้แก่องค์กรของท่านในโอกาสต่อไป
                    </div>
                </CardBox>
            </PartnerContainer>
        </div>
    )
}

export default PartnerThankyouNotInterest